module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAYAAAA1+Nx+AAAAAXNSR0IArs4c6QAAAQNJREFUOBHFkzEOgjAUhmkTnIRbuHoCL+Dg4IIz4QxOHsEzEGaJiYODF/AEJkzeApyUgO+vhVQsUFh8A7R9r98X+gqzKOI4nmRZtuKc33zfv2NtbERRNCuKYu44ztnzvCcHKE3THS0e8zxPwjBcj4VjLxhggQmOEChAm5KHMRLswV5i2QrvI3Bdd88Yu8rEYEkTDhaY4LHKRn2Y0mddyrJcyLUX9WQTBMGpqtG9W+BLOv8H6msBJkMlffAfwRCJCVwrMJGYwlsFXRLk1NsiG1qfOfJqfPVATWCs64msEVexD47aTgEKNBIsWyZwUSeqex5NiSncWIBCKdlijJ+ouueY/zXeGy/WGeknRrIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_arrow_down@2x.png
// module id = 115
// module chunks = 7